import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppModule from "./AppModule";
import Main from "./Main";
import PageNotFound from "./PageNotFound";

export default function Layout() {
    return (
        <>
            <Router>
                {/* <Topnav /> */}
                <Routes>
                    <Route exact path="/" element={<Main />} />
                    <Route exact path="/home" element={<Main />} />
                    <Route exact path="/app" element={<AppModule />} />
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </Router>
        </>
    )
}